import { CSSProperties } from "react"
import { colors, fonts, useMediaQuery } from "../../../Styles"

interface Setting_Props {
  startEnhancer: JSX.Element
  header: string
  content: JSX.Element
  overrides?: {
    content?: CSSProperties
  }
}

export default function SecondarySetting({ startEnhancer, header, content, overrides }:Setting_Props) {

  return (<div style={{display: "flex", flexDirection: "column"}}>
      <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 2px 10px"}}>{header}</p>
      <div style={{backgroundColor: colors.greyLightSecondary, boxSizing: "border-box", width: "610px", borderRadius: "10px", padding: "10px 20px"}}>
        {content}
      </div>
    </div>
  )
}